export const DashboardTrackingIds = {
  moduleAction: (actionLabel: string) => `homepage-dashboard-btn-action-${actionLabel}`,
  featureModule: (featureName: string) => (label: string) => `homepage-dashboard-${featureName}-${label}`,
  mainAction: 'homepage-dashboard-main-action',
};
